export default class UpdateConvocatoria {
  #repository
  constructor(repository) {
    this.#repository = repository
  }
  async execute(idConvocatoria, payload) {
    try {
      const result = await this.#repository.updateConvocatoria(idConvocatoria, payload)
      return result
    } catch (error) {
      console.error('Error al actualizar la convocatoria:', error)
      throw error
    }
  }
}
